import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';

import { AmplitudeService } from './shared/services/amplitude.service';
import { AuthService } from './auth/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(
    private amplitudeService: AmplitudeService,
    private authService: AuthService,
  ) {
    this.amplitudeService.initAmplitude().then(() => {
      if (this.authService.isLoggedIn()) {
        this.amplitudeService.identifyUser(this.authService.getUserInfo());
      }
    });
  }
}
